if (!customElements.get('mobile-bottom-nav')) {
  customElements.define(
    'mobile-bottom-nav',
    class MobileBottomNav extends HTMLElement {
      constructor() {
        super();

        this.searchButton = this.querySelector('[data-open-search]');
        this.menuDrawer = document.getElementById('MenuDrawer');
        this.searchInput = document.querySelector('header input[type="search"]');
        this.searchCloseButton = document.querySelector('.header__search-close');

        this.onSearchClick = this.onSearchClick.bind(this);
        this.updateHighlighted = this.updateHighlighted.bind(this);
        this.onCompareToggle = this.onCompareToggle.bind(this);
        this.calculateHeight = this.calculateHeight.bind(this);
      }

      connectedCallback() {
        document.body.classList.add('mobile-bottom-nav-enabled');

        this.searchButton?.addEventListener('click', this.onSearchClick);
        document.addEventListener('menu-drawer:open', this.updateHighlighted);
        this.menuDrawer?.addEventListener('toggle', this.updateHighlighted);
        this.menuDrawerObserver = new MutationObserver(this.updateHighlighted);
        if (this.menuDrawer) {
          this.menuDrawerObserver.observe(this.menuDrawer, {
            attributes: true,
            attributeFilter: ['open', 'active']
          });
        }

        this.bodyClassObserver = new MutationObserver(this.updateHighlighted);
        this.bodyClassObserver.observe(document.body, {
          attributes: true,
          attributeFilter: ['class']
        });

        if (window.FoxTheme?.pubsub) {
          this.compareToggleUnsubscriber = FoxTheme.pubsub.subscribe('compare:toggle', this.onCompareToggle);
        }

        this.calculateHeight();
        window.addEventListener('resize', this.calculateHeight);
        this.updateHighlighted();

        if (this.isCompareBarShowing()) {
          this.hide();
        }
      }

      disconnectedCallback() {
        document.body.classList.remove('mobile-bottom-nav-enabled');
        this.searchButton?.removeEventListener('click', this.onSearchClick);
        document.removeEventListener('menu-drawer:open', this.updateHighlighted);
        this.menuDrawer?.removeEventListener('toggle', this.updateHighlighted);
        this.menuDrawerObserver?.disconnect();
        this.bodyClassObserver?.disconnect();
        window.removeEventListener('resize', this.calculateHeight);
        if (this.compareToggleUnsubscriber) this.compareToggleUnsubscriber();
      }

      onSearchClick(event) {
        event.preventDefault();
        event.stopPropagation();

        if (document.body.classList.contains('search-open')) {
          this.searchCloseButton?.click();
          return;
        }

        if (typeof this.menuDrawer?.hide === 'function') {
          // Once its close transition ends, the drawer hands focus back to the
          // button that opened it (ModalComponent.handleAfterHide). That pulled
          // focus out of the search field opened below and dropped the iOS
          // keyboard right after it came up.
          this.menuDrawer.activeElement = null;
          this.menuDrawer.hide();
        }

        if (this.openSearchaniseSearch()) return;

        window.scrollTo(0, 0);
        document.querySelector('.header-section')?.classList.remove('header-scrolled');
        this.searchInput?.focus();
      }

      // Searchanise takes over the header search field. In its mobile mode the
      // full-screen search opens on mousedown/touchstart/touchend on that field,
      // not on focus or click, so focusing the field from here left it focused
      // with nothing open. A mousedown runs the same opener a tap on the field
      // does. It opens synchronously, still inside this click, so iOS raises the
      // keyboard for Searchanise's own input. In Searchanise's desktop mode (and
      // without Searchanise) nothing opens and the caller falls back to focus.
      openSearchaniseSearch() {
        if (!this.searchInput) return false;
        this.searchInput.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true }));
        return document.body.classList.contains('snize-instant-widget-is-open');
      }

      isSearchOpen() {
        return document.body.classList.contains('search-open');
      }

      isMenuOpen() {
        return Boolean(this.menuDrawer?.hasAttribute('open') || this.menuDrawer?.hasAttribute('active'));
      }

      updateHighlighted() {
        const items = this.querySelectorAll('.mobile-bottom-nav__item');
        items.forEach((item) => item.classList.remove('is-highlighted'));

        let current = null;
        if (this.isSearchOpen()) {
          current = this.querySelector('[data-nav-item="search"]');
        } else if (this.isMenuOpen()) {
          current = this.querySelector('[data-nav-item="menu"]');
        } else {
          current = this.querySelector('.mobile-bottom-nav__item.is-selected');
        }

        current?.classList.add('is-highlighted');
      }

      calculateHeight() {
        requestAnimationFrame(() => {
          const height = `${this.offsetHeight}px`;
          document.documentElement.style.setProperty('--mobile-bottom-nav-height', height);
          document.documentElement.style.setProperty('--mobile-sticky-bar-height', height);
        });
      }

      isCompareBarShowing() {
        return document.body.classList.contains('is-product-comparing');
      }

      onCompareToggle(event) {
        if (event.isActive) {
          this.hide();
        } else {
          this.show();
        }
      }

      show() {
        this.classList.remove('is-hidden');
        this.calculateHeight();
      }

      hide() {
        this.classList.add('is-hidden');
        document.documentElement.style.setProperty('--mobile-bottom-nav-height', '0px');
        document.documentElement.style.setProperty('--mobile-sticky-bar-height', '0px');
      }
    }
  );
}
